<template>
  <div>
    <h3 class="text-lg">
      Issuing Refund for:
    </h3>

    <div class="py-4 space-y-4">

      <RefundValueSummary
        :selectedItems="selectedItems"
        @update:refund-value="refundValue = $event"
      />

      <div class="flex justify-start space-x-2">
        <div class="font-bold">Reason:</div>
        <div>{{ reason }}</div>
      </div>

      <div class="flex justify-start space-x-2">
        <div class="font-bold">Note:</div>
        <div>{{ note }}</div>
      </div>

      <div v-if="error" class="text-red-500">Something went wrong!</div>

      <div class="flex justify-end items-center space-x-4">
        <Button
          :disabled="! canConfirmRefund"
          @click-handler="confirmRefund()"
          class="flex items-center space-x-2"
        >
          <LoadingSpinner v-if="processing" />
          <span>Confirm</span>
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import MoneyFormatter from "@/mixins/moneyFormatter";
import Button from "@/components/elements/Button.vue";
import RefundValueSummary from "./RefundValueSummary.vue";

const Order = ApiFactory.get('orders');

export default {
  name: "RefundValue",
  components: {
    Button,
    RefundValueSummary,
  },
  filters: {
    currency: MoneyFormatter.format
  },
  mixins: [
    MoneyFormatter
  ],
  props: {
    selectedItems: {
      type: Array,
      required: true,
      default() {
        return [];
      }
    },
    claim: {
      type: String,
      required: true,
    },
    reason: {
      type: String
    },
    note: {
      type: String
    }
  },
  data() {
    return {
      error: false,
      processing: false,
      refundValue: null,
      claims: {
        'guarantee': Order.claimGuarantee,
        'dormancy': Order.claimDormancy,
        'exception': Order.claimException,
      }
    };
  },
  computed: {
    order() {
      return this.$store.getters["orders/get"]("order");
    },
    canConfirmRefund() {
      if (this.processing) {
        return false;
      }

      if (Number(this.refundValue) <=0) {
        return false;
      }

      return true;
    },
  },
  methods: {
    confirmRefund() {
      this.processing = true;
      this.error = false;

      this.claims[this.claim](this.order.SourceOrderNumber, {
        products: this.selectedItems,
        action: 'issue-refund',
        reason: this.reason,
        comments: this.note,
        refundValue: this.refundValue
      }).then(() => {
        this.$emit('finish-processing');
      }).catch(() => {
        this.error = true;
      }).finally(() => {
        this.processing = false;
      });
    },
  }
};
</script>
